import { ITimerMarkTypeItem } from 'ws-voice-infinity-global-module/lib/interfaces';
import { TypeService } from 'ws-voice-infinity-global-module/lib/services';

export enum TimerMarkTypeEnum {
    MODERATION = 'MODERATION',
    IN_WORK = 'IN_WORK',
    IN_WORK_SECONDARY = 'IN_WORK_SECONDARY',
    HAS_MEETING_DATE = 'HAS_MEETING_DATE',
}

interface ITimerMarkType {
    [value: string]: ITimerMarkTypeItem;

    MODERATION: ITimerMarkTypeItem;
    IN_WORK: ITimerMarkTypeItem;
    IN_WORK_SECONDARY: ITimerMarkTypeItem;
    HAS_MEETING_DATE: ITimerMarkTypeItem;
}

const TIMER_MARK_TYPE: ITimerMarkType = {
    MODERATION: {
        name: 'Статус модерации',
        value: 'MODERATION',
        cardTitle: 'Регистрация заявки',
        statusTitle: {
            NEAR_DEADLINE: 'Приближается срок модерации',
            DEADLINE_REACHED: 'Нарушен срок модерации',
        },
        startDateTitle: 'Подача заявки',
        dueDateTitle: 'Плановый срок',
        stopDateTitle: 'Зарегистрировано',
    },
    IN_WORK: {
        name: 'Статус рассмотрения',
        value: 'IN_WORK',
        cardTitle: 'Исполнение',
        statusTitle: {
            NEAR_DEADLINE: 'Приближается срок рассмотрения',
            DEADLINE_REACHED: 'Нарушен срок рассмотрения',
        },
        startDateTitle: 'Принято в работу',
        dueDateTitle: 'Плановый срок до назначения даты приема',
        stopDateTitle: 'Ответ дан',
    },
    IN_WORK_SECONDARY: {
        name: 'Статус повторного рассмотрения',
        value: 'IN_WORK_SECONDARY',
        cardTitle: 'Повторное исполнение',
        statusTitle: {
            NEAR_DEADLINE: 'Приближается срок повторного рассмотрения',
            DEADLINE_REACHED: 'Нарушен срок повторного рассмотрения',
        },
        startDateTitle: 'Направлено',
        dueDateTitle: 'Плановый срок до назначения даты приема',
        stopDateTitle: 'Ответ дан',
    },
    HAS_MEETING_DATE: {
        name: 'Таймер подтверждения приема заявителем',
        value: 'HAS_MEETING_DATE',
        cardTitle: 'Подтверждение приема',
        statusTitle: {
            NEAR_DEADLINE: 'Приближается срок подтверждения приема',
            DEADLINE_REACHED: 'Нарушен срок подтверждения приема',
        },
        startDateTitle: 'Дата назначения приема',
        dueDateTitle: 'Плановый срок подтверждения приема',
        stopDateTitle: 'Дата подтверждения приема',
    },
};

export default TIMER_MARK_TYPE;

export const TimerMarkTypeType = TypeService.createEnum<TimerMarkTypeEnum>(TimerMarkTypeEnum, 'TimerMarkTypeEnum');
